import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconStarRating = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <path d="M32 0L41.888 21.0641L64 24.4627L48 40.8496L51.776 64L32 53.0641L12.224 64L16 40.8496L0 24.4627L22.112 21.0641L32 0Z" />
  </svg>
);

export default IconStarRating;
